//import { AuthService } from '../authorization/services/auth.service';

export const appState: aboTheme.IState = {
  name: 'app',
  url: '/app',
  redirectTo: 'dashboard',
  component: 'app',
  data: {
     requiresAuth: true
  }
};

export const homeState = {
  name: 'home',
  url: '/home',
  component: 'home'
};

export const browserState = {
  name: 'browser',
  url: '/browser',
  component: 'browserPageComponent'
};




// WEBPACK FOOTER //
// ./src/app/main/app.states.ts